// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + "." + {"897":"0162b677de61079a2203","974":"c5a9692a9afe371cac99"}[chunkId] + ".js";
};